import { injectIntl } from 'react-intl';
import SegmentInfo from './SegmentInfo';

export default injectIntl(SegmentInfo);
